import { useState, useEffect } from 'react';
import { Files } from 'helpers/FileHelpers';
import { MediaList } from 'models/BaseModel';


export const useSignatureImage = (fileList: any, setFileList: React.Dispatch<React.SetStateAction<any>>, setSignatureUrl: React.Dispatch<React.SetStateAction<string | null>>, setError: (error: string | null) => void) => {
  const [signatureImage, setSignatureImage] = useState<File | null>(null);

  useEffect(() => {
    const loadProfile = async () => {
      if (fileList?.profile) {
        const profileUrl = await Files.Photo.Fetch(fileList.signature, "images");
        if (profileUrl) {
          setSignatureUrl(profileUrl);
        }
      }
    };

    loadProfile();
  }, [fileList])

  const handleSignatureImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setSignatureImage(event.target.files[0]);
    }
  };

  const handleAttachSignatureImage = async () => {
    if (signatureImage) {
      //const uploadedFile = await Files.ImageAPI.Attach(signatureImage, 200, setError);
      const uploadedFile = await Files.Photo.Attach(signatureImage, "images", 200, setError);
      setFileList((prevFileList: MediaList) => ({
        ...prevFileList,
        signature: uploadedFile,
      }));
    }
  };

  const handleDeleteSignatureImage = () => {
    //Files.ImageAPI.Delete(fileList?.signature, setFileList, setSignatureUrl);
    Files.Photo.Delete(fileList?.signature, "images", setFileList, setSignatureUrl);
  };

  return {
    signatureImage,
    handleSignatureImageChange,
    handleAttachSignatureImage,
    handleDeleteSignatureImage,
  };
};
